<div [@routerTransition]>
    <sub-header
        [title]="('Companies' | localize) + ' ' + ('Details' | localize)"
        [breadcrumbs]="breadcrumbs"
    ></sub-header>

    <div [class]="containerClass">
        <div class="card card-custom gutter-b">
            <div class="card-body">
                <tabset>
                    <tab heading="{{ 'BasicInformation' | localize }}">
                        <div class="row mt-3">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label for="Company_Name">{{ l('Name') }} *</label>
                                    <input
                                        type="text"
                                        #Company_Name="ngModel"
                                        id="Company_Name"
                                        class="form-control"
                                        [(ngModel)]="company.name"
                                        name="Name"
                                        minlength="0"
                                        maxlength="500"
                                        required
                                    />
                                    <validation-messages [formCtrl]="Company_Name"></validation-messages>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label for="Company_AliasName">{{ l('AliasName') }}</label>
                                    <input
                                        type="text"
                                        #Company_AliasName="ngModel"
                                        id="Company_AliasName"
                                        class="form-control"
                                        [(ngModel)]="company.aliasName"
                                        name="AliasName"
                                    />
                                    <validation-messages [formCtrl]="Company_AliasName"></validation-messages>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="Company_Name">{{ l('Code') }} *</label>
                                    <input
                                        type="text"
                                        #Company_Code="ngModel"
                                        id="Company_Code"
                                        class="form-control"
                                        [(ngModel)]="company.code"
                                        name="Name"
                                        minlength="0"
                                        maxlength="50"
                                        required
                                    />
                                    <validation-messages [formCtrl]="Company_Code"></validation-messages>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="Company_BusinessRegistrationNo">
                                        {{ l('BusinessRegistrationNo') }}
                                    </label>
                                    <input
                                        type="text"
                                        #Company_BusinessRegistrationNo="ngModel"
                                        id="Company_BusinessRegistrationNo"
                                        class="form-control"
                                        [(ngModel)]="company.businessRegistrationNo"
                                        name="BusinessRegistrationNo"
                                    />
                                    <validation-messages
                                        [formCtrl]="Company_BusinessRegistrationNo"
                                    ></validation-messages>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="Company_WebSite">{{ l('WebSite') }}</label>
                                    <input
                                        type="text"
                                        #Company_WebSite="ngModel"
                                        id="Company_WebSite"
                                        class="form-control"
                                        [(ngModel)]="company.webSite"
                                        name="WebSite"
                                    />
                                    <validation-messages [formCtrl]="Company_WebSite"></validation-messages>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="Company_Email">{{ l('Email') }}</label>
                                    <input
                                        type="text"
                                        #Company_Email="ngModel"
                                        id="Company_Email"
                                        class="form-control"
                                        [(ngModel)]="company.email"
                                        name="Email"
                                    />
                                    <validation-messages [formCtrl]="Company_Email"></validation-messages>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label for="Company_Remarks">{{ l('Remarks') }}</label>
                                    <input
                                        type="text"
                                        #Company_Remarks="ngModel"
                                        id="Company_Remarks"
                                        class="form-control"
                                        [(ngModel)]="company.remarks"
                                        name="Remarks"
                                    />
                                    <validation-messages [formCtrl]="Company_Remarks"></validation-messages>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="form-label" for="Company_Width">{{ l('Width') }}</label>
                                    <input
                                        type="number"
                                        #Company_Width="ngModel"
                                        id="Company_Width"
                                        class="form-control"
                                        [(ngModel)]="company.width"
                                        name="Width"
                                    />
                                    <validation-messages [formCtrl]="Company_Width"></validation-messages>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="form-label" for="Company_Height">{{ l('Height') }}</label>
                                    <input
                                        type="number"
                                        #Company_Height="ngModel"
                                        id="Company_Height"
                                        class="form-control"
                                        [(ngModel)]="company.height"
                                        name="Height"
                                    />
                                    <validation-messages [formCtrl]="Company_Height"></validation-messages>
                                </div>
                            </div>
                        </div>
                    </tab>
                    <tab heading="{{ 'Address' | localize }}">
                        <div class="row mt-3">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="Company_Address1">{{ l('Address1') }}</label>
                                    <input
                                        type="text"
                                        #Company_Address1="ngModel"
                                        id="Company_Address1"
                                        class="form-control"
                                        [(ngModel)]="company.address1"
                                        name="Address1"
                                    />
                                    <validation-messages [formCtrl]="Company_Address1"></validation-messages>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="Company_Address2">{{ l('Address2') }}</label>
                                    <input
                                        type="text"
                                        #Company_Address2="ngModel"
                                        id="Company_Address2"
                                        class="form-control"
                                        [(ngModel)]="company.address2"
                                        name="Address2"
                                    />
                                    <validation-messages [formCtrl]="Company_Address2"></validation-messages>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="Company_Address3">{{ l('Address3') }}</label>
                                    <input
                                        type="text"
                                        #Company_Address3="ngModel"
                                        id="Company_Address3"
                                        class="form-control"
                                        [(ngModel)]="company.address3"
                                        name="Address3"
                                    />
                                    <validation-messages [formCtrl]="Company_Address3"></validation-messages>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="Company_City">{{ l('City') }}</label>
                                    <input
                                        type="text"
                                        #Company_City="ngModel"
                                        id="Company_City"
                                        class="form-control"
                                        [(ngModel)]="company.city"
                                        name="City"
                                    />
                                    <validation-messages [formCtrl]="Company_City"></validation-messages>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="Company_State">{{ l('State') }}</label>
                                    <input
                                        type="text"
                                        #Company_State="ngModel"
                                        id="Company_State"
                                        class="form-control"
                                        [(ngModel)]="company.state"
                                        name="State"
                                    />
                                    <validation-messages [formCtrl]="Company_State"></validation-messages>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="Company_Country">{{ l('Country') }}</label>
                                    <input
                                        type="text"
                                        #Company_Country="ngModel"
                                        id="Company_Country"
                                        class="form-control"
                                        [(ngModel)]="company.country"
                                        name="Country"
                                    />
                                    <validation-messages [formCtrl]="Company_Country"></validation-messages>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="Company_PostalCode">{{ l('PostalCode') }}</label>
                                    <input
                                        type="text"
                                        #Company_PostalCode="ngModel"
                                        id="Company_PostalCode"
                                        class="form-control"
                                        [(ngModel)]="company.postalCode"
                                        name="PostalCode"
                                    />
                                    <validation-messages [formCtrl]="Company_PostalCode"></validation-messages>
                                </div>
                            </div>
                        </div>
                    </tab>
                    <tab heading="{{ 'Contact' | localize }}">
                        <div class="row mt-3">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="Company_PhoneNumber">{{ l('PhoneNumber') }}</label>
                                    <input
                                        type="text"
                                        #Company_PhoneNumber="ngModel"
                                        id="Company_PhoneNumber"
                                        class="form-control"
                                        [(ngModel)]="company.phoneNumber"
                                        name="PhoneNumber"
                                    />
                                    <validation-messages [formCtrl]="Company_PhoneNumber"></validation-messages>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="Company_FaxNumber">{{ l('FaxNumber') }}</label>
                                    <input
                                        type="text"
                                        #Company_FaxNumber="ngModel"
                                        id="Company_FaxNumber"
                                        class="form-control"
                                        [(ngModel)]="company.faxNumber"
                                        name="FaxNumber"
                                    />
                                    <validation-messages [formCtrl]="Company_FaxNumber"></validation-messages>
                                </div>
                            </div>
                        </div>
                    </tab>
                </tabset>
            </div>
            <div class="card-footer">
                <div class="col-lg-12 text-end">
                    <button
                        (click)="goBack()"
                        class="btn btn-danger me-2"
                        [buttonBusy]="saving"
                    >
                        <i class="fa fa-close"></i>
                        <span>{{ l('Close') }}</span>
                    </button>

                    <button
                        (click)="save()"
                        class="btn btn-primary blue me-2"
                        [buttonBusy]="saving"
                        [busyText]="l('SavingWithThreeDot')"
                    >
                        <i class="fa fa-save"></i>
                        <span>{{ l('Save') }}</span>
                    </button>

                    <button
                        *ngIf="!this.company.id"
                        (click)="saveAndNew()"
                        class="btn btn-primary blue"
                        [buttonBusy]="saving"
                        [busyText]="l('SavingWithThreeDot')"
                    >
                        <i class="fa fa-save"></i>
                        <span>{{ l('SaveAndNew') }}</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>
